import {
  FLASH_MANAGER_EXPORT_PDF,
  FLASH_MANAGER_GET_ALL,
} from '@constants/ApiEndpoints/FlashManagerEndpoints';
import { AxiosInstance } from 'axios';
import { FlashManagerModel } from 'pages/RevenuManagementModule/pages/FlashManagerPage/models';
import { getExportConfig, handleFileExport } from '../../../pages/ReportModule/helpers/fileExport';
import { exportFileTypes } from '../../../pages/ReportModule/models/exportFileTypes';

export const getAll =
  (axios: AxiosInstance) =>
  async (params: { date: string; show_net: boolean }): Promise<FlashManagerModel[]> => {
    return await axios.get(FLASH_MANAGER_GET_ALL, { params }).then(({ data }) => {
      return data;
    });
  };

export const exportPDF =
  (axios: AxiosInstance) =>
  async (params?: {
    date: string;
    show_net: boolean;
    file_type: exportFileTypes;
  }): Promise<void> => {
    return await axios
      .get(`${FLASH_MANAGER_EXPORT_PDF}`, {
        params: { ...params },
        ...getExportConfig(params),
      })
      .then(response => {
        handleFileExport(response, {
          file_type: params?.file_type,
          filename: 'flash-manager-report',
        });
      });
  };
